import englishMessages from 'ra-language-english';
import treeEnglishMessages from 'ra-tree-language-english';
import { mergeTranslations } from 'react-admin';

export const messages = {
    simple: {
        action: {
            close: 'Close',
            resetViews: 'Reset views',
        },
        'create-post': 'New post',
    },
    ...mergeTranslations(englishMessages, treeEnglishMessages),
    pk: {
        register: "Register",
        request_password_reset: "Request Password Reset",
        i_forgot_my_password: "I Forgot My Password",
        login: "Login",
        new_password: "New Password",
        reset_password: "Reset Password",
        reset_password_success: "Reset Password Successful",
        confirm_new_password: "Confirm New Password"
    }
};

export default messages;
